var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 36,
    viewBox: "0 0 126 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2504_1128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3.75C3.75 2.09315 5.09315 0.75 6.75 0.75H30.75C32.4069 0.75 33.75 2.09315 33.75 3.75V17.25H3.75V3.75Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.59549 7.06132C2.41077 5.29093 3.79929 3.75 5.57929 3.75H31.8982C33.6862 3.75 35.0773 5.3042 34.8799 7.08129L33.75 17.25H3.65854L2.59549 7.06132Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.75 32.25C33.75 33.9069 32.4069 35.25 30.75 35.25L6.75 35.25C5.09315 35.25 3.75 33.9069 3.75 32.25L3.75 18.75L33.75 18.75L33.75 32.25Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8799 27.4188C35.0773 29.1958 33.6863 30.75 31.8983 30.75L4.42812 30.75C2.52895 30.75 1.10769 29.0076 1.48931 27.1472L3.5195 17.25L33.7503 17.25L34.8799 27.4188Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.75,
    y: 8.25,
    width: 6,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.75,
    y: 14.25,
    width: 6,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.75,
    y: 14.25,
    width: 6,
    height: 6,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.75,
    y: 20.25,
    width: 6,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.75,
    y: 8.25,
    width: 6,
    height: 6,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.75,
    y: 8.25,
    width: 6,
    height: 6,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.008 29.306C54.4013 29.306 52.2027 28.8187 50.412 27.844C48.6213 26.8467 47.2613 25.43 46.332 23.594C45.4253 21.758 44.972 19.5707 44.972 17.032C44.972 14.516 45.4367 12.34 46.366 10.504C47.2953 8.64533 48.644 7.21733 50.412 6.22C52.18 5.22267 54.2993 4.724 56.77 4.724C58.47 4.724 60.0453 4.97333 61.496 5.472C62.9467 5.97067 64.1593 6.68467 65.134 7.614L63.876 10.368C62.788 9.46133 61.6773 8.81533 60.544 8.43C59.4107 8.022 58.1527 7.818 56.77 7.818C54.118 7.818 52.1007 8.62267 50.718 10.232C49.3353 11.8187 48.644 14.0853 48.644 17.032C48.644 20.0467 49.3467 22.336 50.752 23.9C52.18 25.464 54.3107 26.246 57.144 26.246C58.8667 26.246 60.578 25.9627 62.278 25.396V18.97H56.43V16.318H65.236V27.606C64.216 28.1047 62.9467 28.5127 61.428 28.83C59.932 29.1473 58.4587 29.306 57.008 29.306ZM77.4911 29.306C75.8138 29.306 74.3631 28.9547 73.1391 28.252C71.9151 27.5493 70.9631 26.5633 70.2831 25.294C69.6258 24.002 69.2971 22.472 69.2971 20.704C69.2971 18.936 69.6258 17.4173 70.2831 16.148C70.9631 14.856 71.9151 13.8587 73.1391 13.156C74.3631 12.4533 75.8138 12.102 77.4911 12.102C79.1231 12.102 80.5511 12.4533 81.7751 13.156C82.9991 13.8587 83.9511 14.856 84.6311 16.148C85.3111 17.4173 85.6511 18.936 85.6511 20.704C85.6511 22.472 85.3111 24.002 84.6311 25.294C83.9511 26.5633 82.9991 27.5493 81.7751 28.252C80.5511 28.9547 79.1231 29.306 77.4911 29.306ZM77.4911 26.654C78.8965 26.654 80.0298 26.144 80.8911 25.124C81.7525 24.104 82.1831 22.6307 82.1831 20.704C82.1831 18.7773 81.7525 17.3153 80.8911 16.318C80.0298 15.298 78.8965 14.788 77.4911 14.788C76.0631 14.788 74.9185 15.298 74.0571 16.318C73.1958 17.3153 72.7651 18.7773 72.7651 20.704C72.7651 22.6307 73.1958 24.104 74.0571 25.124C74.9185 26.144 76.0631 26.654 77.4911 26.654ZM96.4137 29.306C94.3284 29.306 92.7757 28.7733 91.7557 27.708C90.7357 26.6427 90.2257 25.1013 90.2257 23.084V15.06H86.9957V12.408H90.2257V7.41H93.6597V12.408H98.7937V15.06H93.6597V22.812C93.6597 24.0133 93.9091 24.92 94.4077 25.532C94.9291 26.144 95.7677 26.45 96.9237 26.45C97.2864 26.45 97.6377 26.416 97.9777 26.348C98.3177 26.2573 98.6577 26.1553 98.9977 26.042L99.5417 28.626C99.2017 28.83 98.7257 28.9887 98.1137 29.102C97.5244 29.238 96.9577 29.306 96.4137 29.306ZM109.38 29.306C106.66 29.306 104.518 28.5467 102.954 27.028C101.39 25.4867 100.608 23.39 100.608 20.738C100.608 19.038 100.948 17.542 101.628 16.25C102.33 14.9353 103.294 13.9153 104.518 13.19C105.742 12.4647 107.147 12.102 108.734 12.102C111.023 12.102 112.825 12.8387 114.14 14.312C115.454 15.7627 116.112 17.7687 116.112 20.33V21.486H103.94C104.189 24.9313 106.014 26.654 109.414 26.654C110.366 26.654 111.295 26.5067 112.202 26.212C113.131 25.9173 114.004 25.43 114.82 24.75L115.84 27.13C115.092 27.81 114.128 28.3427 112.95 28.728C111.771 29.1133 110.581 29.306 109.38 29.306ZM108.87 14.516C107.442 14.516 106.308 14.958 105.47 15.842C104.631 16.726 104.121 17.9047 103.94 19.378H113.222C113.154 17.8367 112.746 16.6467 111.998 15.808C111.25 14.9467 110.207 14.516 108.87 14.516ZM119.549 8.566V4.996H123.561V8.566H119.549ZM119.855 29V12.408H123.289V29H119.855Z",
    fill: "#42526E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2504_1128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 36,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ef3869f0.svg";
export { ForwardRef as ReactComponent };